/* Event snippet for 구매_210906 conversion page In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. */
function gtag_report_conversion(trans_id,url) { 
  var callback = function () { 
    if (typeof(url) != 'undefined') { window.location = url; }
  };
  gtag('event', 'conversion', { 'send_to': 'AW-17285883461/uxiKCNepseYaEMXMxrJA', 'transaction_id': trans_id, 'event_callback': callback }); 
  return false;
}





/* 상품 페이지에서 장바구니 담기, Add to cart */
  var elmtClass = document.getElementsByClassName("add-to-cart");
  Array.prototype.forEach.call(elmtClass, function(element) {
    element.addEventListener("click", function() {
      trans_id = this.id;
      //console.log(trans_id);
      gtag_report_conversion(trans_id);
    });
  });

/* 상품 페이지에서 구매, checkout :: paypal */
  var elmtClass = document.getElementsByClassName("shopify-payment-button");
  Array.prototype.forEach.call(elmtClass, function(element) {
    element.addEventListener("click", function() {

      sect_id = document.getElementById( 'shopify-section-product-template' ).getElementsByClassName( 'product-section' )[0].getAttribute("data-section-id");
      prd_sect_id = 'ProductSelect-'+sect_id;
      variant_id = document.getElementById( prd_sect_id );
      variant_id = variant_id.options[variant_id.selectedIndex].value;

      trans_id = sect_id+'-'+variant_id;
      //console.log(trans_id);
      gtag_report_conversion(trans_id);
    });
  });


/* 카트에서 checkout */
/*
var elmtClass = document.getElementsByClassName("cart__checkout");
Array.prototype.forEach.call(elmtClass, function(element) {
  element.addEventListener("click", function() {
    gtag_report_conversion();
  });
});
*/

/* 카트에서 continue shopping */
/*
var elmtClass = document.getElementsByClassName("cart__continue");
Array.prototype.forEach.call(elmtClass, function(element) {
  element.addEventListener("click", function() {
    gtag_report_conversion();
  });
});
*/

/*
document.addEventListener("DOMContentLoaded", function(){
  var html_lang = document.documentElement.lang;
  console.log(html_lang+'<<< 1st ');
});


window.onload = function () { 
  var html_lang = document.documentElement.lang;
  console.log(html_lang+'<<< 2nd');  
}
*/